import { useEffect, useState } from "react";
import { PreCandidateService } from "../../../../services/PreCandidate";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import Select from "../../../../components/Select";

export function InactiveManagers({ searchObject, onChange, t }) {
  const [inactiveManagers, setInactiveManagers] = useState([]);

  useEffect(() => {
    PreCandidateService.GetInactiveManagerList().then((data) =>
      setInactiveManagers(data)
    );
  }, []);

  return (
    <div>
      <legend className="fontsize-legend">{t("Others Managers")}</legend>
      <Select
        className="form-select fontsize-legend"
        name="managerId"
        onChange={onChange}
        value={searchObject.managerId || ""}
      >
        <option value=""></option>
        {inactiveManagers.map((managers) => (
          <option
            className="fontsize-legend"
            key={managers.id}
            value={managers.id}
          >
            {managers.nickname}
          </option>
        ))}
      </Select>
    </div>
  );
}
